import React from "react";
import "./SimplexDuplexTriplexTransmissionChain.css";
import simimg from "./simplex.jpg";

const SimplexDuplexTriplexTransmissionChain = () => {
  return (
    <div className="main-simplex">
      <div className="second-simplex">
        <div className="simplex">
          <p>Simplex, Duplex, TriplexTransmission Chain</p>
          <div>
            <p className="sim2">
              Swajit Engineering Pvt.Ltd.>Simplex, Duplex, TriplexTransmission
              Chain
            </p>
          </div>
        </div>
        <div className="duplex">
          <h1 className="best2">
            Simplex, Duplex, Triplex Transmission Chain Manufacturers In India
          </h1>
          <p>
            With vast experience in the field of conveying systems, we at Swajit
            engineering Pvt ltd. are prominent Simplex, Duplex, Triplex
            Transmission Chain Manufacturers in Aurangabad, Maharashtra India.
            These chains are checked under stringent quality control that
            ensures optimum performance in harsh conditions. Our simplex,
            duplex, and triplex chains are made up of carbon steel and stainless
            steel with polished finishing. Our chains are highly applauded by
            the customers for their durability, heat resistance, stronger, and
            efficient performance.
          </p>

          <div className="sim-chain">
            <img src={simimg} alt="img"></img>

            <div className="sim-chain1">
              <div className="sim-chain2">
                <p className="">
                  We are providing a huge range of transmission chains to the
                  industries such as:
                </p>
                <ul>
                  <li> Pipe handling</li>
                  <li>Pharmaceutical</li>
                  <li>Chemical food & beverage</li>
                  <li>Plastic injection mold</li>
                  <li>Packaging</li>
                  <li>Fibregalss insulation</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="sim-chain3">
            <h3>
              Advantages of the best Simplex, Duplex, Triplex Transmission Chain
              Manufacturer in India:
            </h3>
            <ul>
              <li>
                Owing to its durability, oiling lubrications, frictions, speed,
                quality, and structure, products can be moved easily and quickly
                on it.
              </li>
              <li>Pharmaceutical</li>
              <li>
                It is designed with a variable speed system that helps to
                control speed while operating or process.
              </li>
              <li>
                The premium quality raw materials are sourced from trustworthy
                vendors while manufacturing and designing transmission chains
                that allow increased productivity.
              </li>
              <li>
                The Length, sizes, dimensions, shapes, width, capacity, and
                other specifications of transmission chains are available in
                customized options.
              </li>
            </ul>
            <p>Contact us on 9922941689 or Email marketing@swajit.com.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimplexDuplexTriplexTransmissionChain;
